function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64000 10000",
    style: {
      shapeRendering: "geometricprecision"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#F2971D",
      fontFamily: "Futura, PT",
      fontSize: 10000,
      fontWeight: "bold"
    },
    x: 1872.78,
    y: 9000
  }, "Auto"), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#FFFFFF",
      fontFamily: "Futura, PT",
      fontSize: 10000,
      fontWeight: "bold",
      whiteSpace: "pre"
    },
    x: 29000,
    y: 9000
  }, "Palace"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dffed46f6f1751daffbdfae9901d254d.svg";
export { ForwardRef as ReactComponent };